import { CmpsPopulationCompareResult } from '@cmps/ng-kit';

import {
    MetricData,
    PerformanceDataViewType,
} from '../performance-data/metric.pd.model';
import { createAction } from '../store.model';
import { User } from '../user/user.model';
import { PeriodType } from '../widget/date-range.widget.model';

import { CacheDate } from './models/cache-model';
import { CustomPerformanceDataViewType } from './models/customer-performance-data-view-type.enum';
import { PerformanceCard } from './models/performance-card.model';
import { PerformancePeriodCompare } from './models/period-compare.model';
import { PerformancePopulationCompare } from './models/population-compare.model';

export enum ActionType {
    MY_PERFORMANCE_CARD__ROOT__RELOAD = 'MY_PERFORMANCE_CARD__ROOT__RELOAD',
    MY_PERFORMANCE_CARD__ROOT__RELOAD_RESULT = 'MY_PERFORMANCE_CARD__ROOT__RELOAD_RESULT',
    MY_PERFORMANCE_CARD_SELECT_MENU_ITEM = 'MY_PERFORMANCE_CARD_SELECT_MENU_ITEM',
    MY_PERFORMANCE_CARD_SELECT_PERIOD_COMPARE = 'MY_PERFORMANCE_CARD_SELECT_PERIOD_COMPARE',
    MY_PERFORMANCE_CARD_SELECT_PERIOD_COMPARE_RESULT = 'MY_PERFORMANCE_CARD_SELECT_PERIOD_COMPARE_RESULT',
    MY_PERFORMANCE_CARD_SELECT_POPULATION_COMPARE = 'MY_PERFORMANCE_CARD_SELECT_POPULATION_COMPARE',
    MY_PERFORMANCE_CARD_SELECT_POPULATION_COMPARE_RESULT = 'MY_PERFORMANCE_CARD_SELECT_POPULATION_COMPARE_RESULT',
    MY_PERFORMANCE_CARD_ROOT__CLEAR_STATE = 'MY_PERFORMANCE_CARD_ROOT__CLEAR_STATE',
}
export interface RootReloadAction {
    user?: User;
}

export const reload = createAction<ActionType, RootReloadAction>(
    ActionType.MY_PERFORMANCE_CARD__ROOT__RELOAD,
);
export interface ReloadResultAction extends RootReloadAction {
    performanceCard?: PerformanceCard;
    periodCompare?: PerformancePeriodCompare;
    populationCompare?: PerformancePopulationCompare;
}

export const reloadResult = createAction<ActionType, ReloadResultAction>(
    ActionType.MY_PERFORMANCE_CARD__ROOT__RELOAD_RESULT,
);
export interface SelectMenuItemAction {
    index?: number;
    menuItemId?: PerformanceDataViewType | CustomPerformanceDataViewType;
}

export const selectMenuItem = createAction<ActionType, SelectMenuItemAction>(
    ActionType.MY_PERFORMANCE_CARD_SELECT_MENU_ITEM,
);
export interface SelectPeriodAction {
    user?: User;
    selectedDate?: CacheDate;
    pillarIndex?: number | undefined;
    cardType?: string;
}

export const selectPeriod = createAction<ActionType, SelectPeriodAction>(
    ActionType.MY_PERFORMANCE_CARD_SELECT_PERIOD_COMPARE,
);

export interface SelectPeriodResultAction extends SelectPeriodAction {
    performanceCard?: PerformanceCard;
}

export const selectPeriodResult = createAction<
    ActionType,
    SelectPeriodResultAction
>(ActionType.MY_PERFORMANCE_CARD_SELECT_PERIOD_COMPARE_RESULT);
export interface SelectPopulationAction {
    user?: User;
    selectedData?: CmpsPopulationCompareResult;
    pillarIndex?: number | undefined;
    periodType?: PeriodType;
    metricsIds?: number[];
}

export const selectPopulation = createAction<
    ActionType,
    SelectPopulationAction
>(ActionType.MY_PERFORMANCE_CARD_SELECT_POPULATION_COMPARE);

export interface SelectPopulationResultAction extends SelectPopulationAction {
    metrics?: MetricData[];
}

export const selectPopulationResult = createAction<
    ActionType,
    SelectPopulationResultAction
>(ActionType.MY_PERFORMANCE_CARD_SELECT_POPULATION_COMPARE_RESULT);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootClearStateAction {}

export const clearState = createAction<ActionType, RootClearStateAction>(
    ActionType.MY_PERFORMANCE_CARD_ROOT__CLEAR_STATE,
);
